import { Box } from '@ally/metronome-ui'

import styled from 'styled-components'

const InputWrapper = styled(Box)`
  ${({ theme: { media } }): string => `
    max-width: 235px;

    ${media.down('md')} {
      width: 100%;
      max-width: none;
    }
  `}
`

export default InputWrapper
